/**
 * Creates a monotonic now function that returns the number of milliseconds
 * elapsed since the time origin.
 *
 * This function exist to be able to unit test `monotonicNow()` without having
 * to mock `performance.now()` and `Date.now()`.
 *
 * @param performanceNow - The `performance.now()` function.
 * @param dateNow - The `Date.now()` function.
 * @returns A monotonic now function.
 */
export function createMonotonicNow(performanceNow, dateNow) {
    try {
        if (typeof performanceNow() === 'number') {
            return performanceNow;
        }
    }
    catch (_a) {
        // Fall back to `Date.now()` if `performance.now()` throws.
    }
    const timeOrigin = dateNow();
    let monotonicTime = 0;
    return () => {
        monotonicTime = Math.max(monotonicTime, dateNow() - timeOrigin);
        return monotonicTime;
    };
}
//# sourceMappingURL=create_monotonic_now.js.map